import React from "react";
import JournalCard from "./Card";

const SavedSection = ({
  savedPosts,
  onLoadMore,
  hasMore,
  isLoading,
  onPostSaved,
  userProfile,
  members,
  onPostUpdated,
  onPostHide,
  onUserClicked,
  onGroupClicked,
  onPost,
}) => {
  return (
    <div style={{ color: "#fff" }}>
      {savedPosts.length === 0 ? (
        <p style={{ margin: "30px" }}>No saved posts yet.</p>
      ) : (
        <>
          {savedPosts.map((post) => (
            <JournalCard
              key={post.id}
              post={post}
              onPostSaved={onPostSaved}
              userProfile={userProfile}
              members={members}
              onPostUpdated={onPostUpdated}
              onPostHide={onPostHide}
              onUserClicked={onUserClicked}
              onGroupClicked={onGroupClicked}
              onPost={onPost}
              isPost
            />
          ))}
          {/* {hasMore && (
            <button
              onClick={onLoadMore}
              disabled={isLoading}
              style={{
                display: "block",
                margin: "20px auto",
                padding: "10px 20px",
                backgroundColor: "#008CFF",
                color: "white",
                border: "none",
                borderRadius: "5px",
                cursor: "pointer",
              }}
            >
              {isLoading ? "Loading..." : "Load More"}
            </button>
          )} */}
          {isLoading && (
            <div className="text-center py-2">
              <div className="spinner-border text-primary" role="status" />
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default SavedSection;
